<template>
  <div class="container-fluid" id="battery-evap-info">
    <div class="row">
      <div class="es-xs-8">
        <h4>
          {{ project.evaporatorBatteryId.name }}
        </h4>
        <h5 v-if="project.model">{{ project.model }}</h5>
        <h6 v-if="project.mainProjectInfo">
          {{ project.mainProjectInfo.title }} /
          {{ project.mainProjectInfo.seriesInfo.title }}
        </h6>
      </div>
      <div class="es-xs-12">
        <BatteryDrawerDetail
          for-pdf
          @battery-loaded="batteryLoaded"
          :batteryId="project.evaporatorBatteryId.id"
          :battery="project.evaporatorBatteryId"
        ></BatteryDrawerDetail>
      </div>
    </div>
  </div>
</template>

<script>
import BatteryDrawerDetail from "@/components/Batteries/BatteryDrawerDetail.vue";
import html2pdf from "html2pdf.js";

export default {
  components: { BatteryDrawerDetail },
  props: {
    project: {
      type: Object,
    },
  },
  methods: {
    async batteryLoaded() {
      const pdfBlob = await this.createPdfBlob();
      const file = this.blobToFile(pdfBlob, "evaporator-battery-info.pdf");
      this.$emit("pdf-created", file);
      const url = URL.createObjectURL(pdfBlob);
      this.$emit("pdf-created-link", url);
      return file;
    },
    // 1. Yöntem: Blob olarak almak
    async createPdfBlob() {
      return new Promise((resolve) => {
        const element = document.getElementById("battery-evap-info");
        const opt = {
          margin: [28, 4, 40, 4],
          filename: this.project.evaporatorBatteryId.name + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
          },
          jsPDF: {
            unit: "mm",
            format: "a4",
            orientation: "portrait",
          },
        };

        const footerImg = "/pdf-footer.png";
        const headerImg = "/pdf-header.png";
        //const footerLogo = ;
        html2pdf()
          .from(element)
          .set(opt)
          .toPdf()
          .get("pdf")
          .then((pdf) => {
            var totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
              // set footer to every page
              pdf.setPage(i);
              // set footer font
              pdf.setFontSize(10);
              pdf.setTextColor(150);
              pdf.addImage(
                footerImg,
                "png",
                10,
                pdf.internal.pageSize.getHeight() - 30,
                pdf.internal.pageSize.getWidth() - 20,
                30
              );
              pdf.addImage(
                headerImg,
                "png",
                10,
                0,
                pdf.internal.pageSize.getWidth() - 20,
                25
              );
              // pdf.addImage(
              //   footerLogo,
              //   "png",
              //   0,
              //   0,
              //   pdf.internal.pageSize.getWidth(),
              //   0.3
              // );
            }
            resolve(pdf.output("blob"));
          });
      });
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName, { type: "application/pdf" });
    },
  },
};
</script>

<style></style>
